(ns manatee.admin.task-config.edit.handlers
  (:require [ajax.edn :refer [edn-response-format]]
            [kee-frame.core :as kf]
            [manatee.admin.task-config.handlers :as task-config-handlers]
            [manatee.annotation.handlers :as annotation]
            [manatee.components.notifications.handlers :as notifications]
            [re-frame.core :as rf]))

(kf/reg-controller ::edit-task
                   {:params (fn [{:keys [handler] :as params}]
                              (when (= handler ::admin)
                                params))
                    :start (fn [_ _] [::load-edit-task-view])})

(rf/reg-fx
 :load-edit-task-view
 (fn load-edit-task-view
   [{:keys [db]} params]
   (let [[_ initial-tab] params]
     {:db db
      :dispatch [::select-tab initial-tab]})))

(rf/reg-event-fx
 ::edit-task
 (fn edit-task
   [{:keys [db]} [_ task-config uploaded-submissions reenable-submit]]
   {:db db
    :http-xhrio {:method :put
                 :uri (kf/path-for [:api/task-configs])
                 :body (task-config-handlers/task-request-body
                        (assoc task-config :form-data? true)
                        uploaded-submissions)
                 :response-format (edn-response-format)
                 :on-success [::edit-task-success reenable-submit]
                 :on-failure [::edit-task-failure reenable-submit]}}))

(rf/reg-event-fx
 ::edit-task-success
 (fn edit-task-success
   [{:keys [db]} [_ reenable-submit _response]]
   (reenable-submit)
   {:db db
    :dispatch-n [[::annotation/load-task-configs]
                 [::notifications/add-alert :main
                  {:message "Task config updated successfully."
                   :type :info}
                  :auto-dismiss? true]]}))

(rf/reg-event-fx
 ::edit-task-failure
 (fn edit-task-failure
   [_ [_ reenable-submit info]]
   (reenable-submit)
   {:dispatch [::notifications/add-alert :main
               {:message (if (get-in info [:response :reason])
                           (str "Unable to edit task: " (get-in info [:response :reason]))
                           "Error updating task")
                :type :error}
               :auto-dismiss? false]}))
